import angular from 'angular';
import uiRouter from 'angular-ui-router';
import bookingComponent from './booking.component';
import cacheService from '../../../services/cache.service';
//Child states
import view from './view/view';
import amend from './amend/amend';
import cancel from './cancel/cancel';
import goldupgrade from './goldupgrade/goldupgrade';
import invoice from './invoice/invoice';



const bookingModule = angular.module('booking', [
    uiRouter,
    cacheService,
    view,
    amend,
    cancel,
    goldupgrade,
    invoice
])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('bookings.booking', {
                resolve: {
                    data: function ($stateParams, $q, myBookingService, cacheService, authService, $state) {
                        'ngInject';
                        let bookingReference = cacheService.get('bookingReference');
                        if ($stateParams.bookingReference == bookingReference) {
                            return myBookingService.getGlobalInfoBooking(bookingReference).then(booking => {
                                return booking;
                            }, function (error) {
                                if (error.status === 401) {
                                    authService.clearSession();
                                    $state.go('auth.login');
                                }
                                return null;
                            });
                        } else {
                            return deferred.promise;
                        }
                    }
                },                            
                url: '/:bookingReference',
                abstract: true,
                redirectTo: 'bookings.booking.view',
                views: {
                    'main@': {
                        template: '<booking data="$resolve.data"></booking>'
                    }
                }
            })
    })
    .component('booking', bookingComponent)
    .name
export default bookingModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/booking.js